import { WSActions, WSList, WSPanel } from "@wingspanhq/fe-component-library";
import React from "react";
import { AboutPGLI } from "../../../components/customBenefits/PGLI/AboutPGLI";
import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepAbout: React.FC<FlowStep> = props => {
  return (
    <WSPanel>
      <WSList gap="2XL">
        <AboutPGLI />

        <WSActions
          alignment="fill"
          buttons={[
            {
              kind: "Tertiary",
              onClick: props.onBack,
              label: "Back"
            },
            {
              label: "Continue",
              type: "submit",
              onClick: props.onNext
            }
          ]}
        />
      </WSList>
    </WSPanel>
  );
};
